import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import quote from "svg/quote.svg";
import AccountLookup from "common/accountLookup";
import CustomTooltip from "common/tooltip";
import MultiSelectInput from "common/multiSelectInput";
import InputField from "common/customInputField";
import MobileDataTable from "common/mobileDataTable";
import Button from "react-bootstrap/Button";
import deleteIcon from "svg/delete_icon.svg";
import pencil from "svg/pencil.svg";
import Modal from "common/modal";
import axios from "services/config";
import EditExceptionPriceModal from "common/editExceptionPriceModal";
import { showSpinner, hideSpinner } from "store/slices/spinner";
import { isMobile } from "utils/common";
import {
  addExcepPrice,
  editPrice,
  deletePrice,
  updateExpSearchValues,
  showExpPrice,
} from "store/laborTable/actionCreator";
import { getlaborCodeValues } from "store/priceQuote/actionCreator";
import { expPriceHeaders, currencyValue } from "./utils";
import { getPriceService } from "services/laborTable.service";
import { getJobDetailsService } from "services/priceQuote.service";
import { displayMobileRowItem } from "../common/mobileDataTable/utils";
import { getExcepPrices } from "store/slices/laborTable";
import { toast } from "react-toastify";
import "./style.scss";

const ExceptionPricing = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tableBodyNode = useRef();
  const laborCodesNode = useRef();
  const autoFocus = useRef(null);
  const { storeCcn, sub, fcRole } = useSelector((state) => state.loggedInUser);
  const { exceptionPriceSearchList, showPriceTable, exceptionPriceSearchFields, isExpPrice } = useSelector(
    (state) => state.laborTable,
  );
  const { laborCodeLookupData } = useSelector((state) => state.priceQuote);
  const tdClass = "table-root-floor__body__tr__td table-root-floor__body__tr__td__text";
  const [laborCodeRow, setLaborCodeRow] = useState({
    laborCode: "",
    description: "",
    laborCodeId: "",
    standardBillRate: "",
    installerPayRate: "",
    installerPayRateNum: "",
    exceptionBillRate: "",
    exceptionInstallerPayRate: "",
  });

  const [isShowAddLaborCodes, setIsShowAddLaborCodes] = useState(false);
  const [laborCodes, setLaborCodes] = useState([]);
  const [priceValid, setPriceValid] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editData, setEditData] = useState();
  const [deleteData, setDeleteData] = useState();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [jobList, setJobList] = useState([]);
  const [accChange, setAccChange] = useState(false);
  const [accNum, setAccNum] = useState();

  useEffect(() => {
    if (autoFocus.current && laborCodeRow.laborCode) {
      autoFocus.current.focus();
    }
  }, [laborCodeRow.laborCode]);

  const handleJob = (e, value) => {
    let tempObj = {
      id: value.jobNbr,
      label: value.jobNbr,
      description: !value.jobName ? "" : value.jobName,
    };
    dispatch(updateExpSearchValues("job", tempObj));
  };

  useEffect(() => {
    if (exceptionPriceSearchFields.accountNumber?.length == 9) {
      getJobDetailsService(exceptionPriceSearchFields.accountNumber)
        .then((res) => {
          if (res.length > 1) {
            setJobList(res);
            var defaultJob = res.reduce((previous, current) => {
              return current.jobNbr < previous.jobNbr ? current : previous;
            });
            if (accChange) {
              let tempObj = {
                id: defaultJob.jobNbr,
                label: defaultJob.jobNbr,
                description: defaultJob.jobName,
              };
              dispatch(updateExpSearchValues("job", tempObj));
            }
          } else if (res.length === 1) {
            setJobList(res);
            if (accChange) {
              let tempObj = {
                id: res[0].jobNbr,
                label: res[0].jobNbr,
                description: res[0].jobName,
              };
              dispatch(updateExpSearchValues("job", tempObj));
            }
          } else {
            setJobList([]);
            let tempObj = {
              id: "",
              label: "",
              description: "",
            };
            dispatch(updateExpSearchValues("job", tempObj));
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  }, [exceptionPriceSearchFields.accountNumber]);

  useEffect(() => {
    dispatch(getlaborCodeValues());
  }, []);

  useEffect(() => {
    if (storeCcn) dispatch(showExpPrice(storeCcn));
  }, [storeCcn]);

  useEffect(() => {
    if (exceptionPriceSearchFields.accountNumber === accNum) {
      setAccChange(false);
    } else {
      setAccChange(true);
    }
  }, [exceptionPriceSearchFields]);

  useEffect(() => {
    let laborCodesArr = [];
    exceptionPriceSearchList.map((item) => {
      laborCodesArr.push(item.laborCode);
    });
    setLaborCodes(laborCodesArr);
  }, [exceptionPriceSearchList]);

  useEffect(() => {
    dispatch(updateExpSearchValues("storeNumber", storeCcn));
  }, [storeCcn]);

  const handleSearch = () => {
    const payload = {
      accountNumber: exceptionPriceSearchFields.accountNumber,
      storeNbr: exceptionPriceSearchFields.storeNumber,
      jobNumber:
        !exceptionPriceSearchFields.job?.id ||
        (exceptionPriceSearchFields.job?.id && exceptionPriceSearchFields.job?.id.length > 3)
          ? ""
          : exceptionPriceSearchFields.job?.id.toString(),
      isExceptionPrice: true,
    };
    if (
      !exceptionPriceSearchFields.accountNumber ||
      !exceptionPriceSearchFields.job?.id ||
      exceptionPriceSearchFields.job?.id.length > 3
    ) {
      toast.error("Please enter account and job information to proceed");
    } else {
      dispatch(showSpinner());
      axios
        .get("/fc-labor-table/laborTable/laborCodeSearch", { params: payload })
        .then((res) => {
          return Promise.resolve(res.data);
        })
        .catch((err) => Promise.reject(err))
        .then((res) => {
          res.map((item) => {
            item.exceptionPrice = !item.exceptionPrice ? "0" : parseFloat(item.exceptionPrice).toFixed(2).toString();
            item.installerRate = !item.installerRate ? "0" : parseFloat(item.installerRate).toFixed(2).toString();
            item.standardBillRate = !item.standardBillRate
              ? "0"
              : parseFloat(item.standardBillRate).toFixed(2).toString();
            item.standardInstallerRate = !item.standardInstallerRate
              ? "0"
              : parseFloat(item.standardInstallerRate).toFixed(2).toString();
          });
          dispatch(getExcepPrices(res));
          dispatch(hideSpinner());
          return res;
        })
        .catch((err) => {
          console.log("err", err);
          dispatch(hideSpinner());
        });
    }
  };

  const onAccountNumberChange = (accNo) => {
    dispatch(updateExpSearchValues("accountNumber", accNo));
    setAccNum(accNo);
  };

  const onAccountNameChange = (accName) => {
    dispatch(updateExpSearchValues("accountName", accName));
  };

  const handleEditPrice = (data) => {
    setPriceValid("");
    setEditData({
      ...data,
      exceptionBillRate: parseFloat(data.exceptionPrice).toFixed(2),
      installerRate: parseFloat(data.installerRate).toFixed(2),
    });
    setShowEditModal(true);
  };

  const handleDeletePrice = (data) => {
    setDeleteData(data);
    setShowDeleteModal(true);
  };

  const handleAddExceptionPrice = (isShow) => {
    if (isShow) {
      setIsShowAddLaborCodes(true);
      setLaborCodeRow({});
    } else {
      setIsShowAddLaborCodes(false);
    }
  };

  const handleLaborCodeLookupValue = (e, value, prd, clickevn) => {
    const laborDetails = JSON.parse(clickevn.target.dataset.selectedmetadata);
    if (clickevn) {
      dispatch(showSpinner());
      getPriceService(laborDetails.id, storeCcn)
        .then((res) => {
          setLaborCodeRow({
            ...laborCodeRow,
            laborCodeId: laborDetails.id,
            laborCode: laborDetails.laborCode,
            description: laborDetails.description,
            exceptionInstallerPayRate:
              !res.installerPayRate || res.installerPayRate == null || res.installerPayRate == "null"
                ? 0.0
                : res.installerPayRate,
            standardBillRate:
              !res.laborBillRate || res.laborBillRate == null || res.laborBillRate == "null"
                ? currencyValue("0")
                : currencyValue(res.laborBillRate),
            installerPayRate:
              !res.installerPayRate || res.installerPayRate == null || res.installerPayRate == "null"
                ? currencyValue("0")
                : currencyValue(res.installerPayRate),
            installerPayRateNum:
              !res.installerPayRate || res.installerPayRate == null || res.installerPayRate == "null"
                ? "0"
                : res.installerPayRate,
          });
          dispatch(hideSpinner());
        })
        .catch((err) => {
          console.error(err);
          dispatch(hideSpinner());
        });
    }
  };

  const handleLaborLookupChange = (e) => {
    const key = e.target.id;
    const value = e.target.value;
    if (key === "exceptionBillRate") {
      laborCodeRow.exceptionBillRate = value;
    }
    if (key === "exceptionInstallerPayRate") {
      laborCodeRow.exceptionInstallerPayRate = value;
    }
    setLaborCodeRow({ ...laborCodeRow });
  };

  const handleEditFields = (e) => {
    const value = e.target.value;
    const key = e.target.id;
    if (key === "exceptionBillRate") {
      editData.exceptionBillRate = value;
    }
    if (key === "expInstallerPayRate") {
      editData.installerRate = value;
    }
    setEditData({ ...editData });
  };

  const addLaborCode = () => {
    let isValid = false;
    isValid = checkValidation(false);
    if (isValid) {
      handleAddExceptionPrice(false);
      savePrice();
    }
  };

  const savePrice = () => {
    const payload = {
      accountNumber: exceptionPriceSearchFields.accountNumber,
      accountName: exceptionPriceSearchFields.accountName,
      jobNumber:
        !exceptionPriceSearchFields.job.id ||
        (exceptionPriceSearchFields.job.id && exceptionPriceSearchFields.job.id.length > 3)
          ? ""
          : exceptionPriceSearchFields.job.id,
      jobName: exceptionPriceSearchFields.job.description,
      storeNumber: storeCcn,
      laborCodeId: laborCodeRow.laborCodeId,
      laborBillRate: laborCodeRow.exceptionBillRate,
      installerPayRate: laborCodeRow.exceptionInstallerPayRate.toString(),
      createdBy: sub,
    };

    const expPayload = {
      accountNumber: exceptionPriceSearchFields.accountNumber,
      storeNbr: exceptionPriceSearchFields.storeNumber,
      jobNumber: exceptionPriceSearchFields.job?.id,
    };
    dispatch(addExcepPrice(payload, expPayload));
  };

  const handleSave = () => {
    const editPayload = {
      accountNumber: exceptionPriceSearchFields.accountNumber,
      jobNumber:
        !exceptionPriceSearchFields.job?.id ||
        (exceptionPriceSearchFields.job?.id && exceptionPriceSearchFields.job?.id.length > 3)
          ? ""
          : exceptionPriceSearchFields.job?.id,
      storeNumber: storeCcn,
      laborCodeId: editData?.id,
      laborBillRate: parseFloat(editData?.exceptionBillRate).toFixed(2),
      installerPayRate: parseFloat(editData?.installerRate).toFixed(2),
      updatedBy: sub,
    };
    const searchPayload = {
      accountNumber: exceptionPriceSearchFields.accountNumber,
      storeNbr: exceptionPriceSearchFields.storeNumber,
      jobNumber: exceptionPriceSearchFields.job.id,
    };
    if (showWarning && !showEditModal) {
      setShowWarning(false);
      setIsShowAddLaborCodes(false);
      savePrice();
    } else if (showEditModal && showWarning) {
      setShowWarning(false);
      setShowEditModal(false);
      dispatch(editPrice(editPayload, searchPayload));
    } else if (showEditModal) {
      let isValid = false;
      isValid = checkValidation(true);
      if (isValid) {
        setShowEditModal(false);
        dispatch(editPrice(editPayload, searchPayload));
      }
    } else if (showDeleteModal) {
      const deletePayload = {
        accountNumber: exceptionPriceSearchFields.accountNumber,
        jobNumber:
          !exceptionPriceSearchFields.job.id ||
          (exceptionPriceSearchFields.job.id && exceptionPriceSearchFields.job.id.length > 3)
            ? ""
            : exceptionPriceSearchFields.job.id,
        storeNumber: storeCcn,
        laborCodeId: deleteData.id,
      };
      setShowDeleteModal(false);
      dispatch(deletePrice(deletePayload, searchPayload));
    }
  };

  const handleCancel = () => {
    if (showEditModal && showWarning) {
      setShowWarning(false);
    } else if (showEditModal && !showWarning) {
      setShowEditModal(false);
    } else if (showWarning) {
      setShowWarning(false);
    }
    setShowDeleteModal(false);
  };

  const checkValidation = (isEdit) => {
    let valid = true;
    if (isEdit) {
      if (parseFloat(editData.exceptionBillRate) < parseFloat(editData.installerRate)) {
        valid = false;
        setPriceValid("Exception Price cannot be less than Exception Installer Pay Rate");
      } else if (parseFloat(editData.exceptionBillRate) === parseFloat(editData.installerRate)) {
        setShowWarning(true);
        valid = false;
      }
    } else {
      if (parseFloat(laborCodeRow.exceptionBillRate) < parseFloat(laborCodeRow.exceptionInstallerPayRate)) {
        valid = false;
        toast.error("Exception price cannot be less than exception installer pay rate");
      } else if (parseFloat(laborCodeRow.exceptionBillRate) === parseFloat(laborCodeRow.exceptionInstallerPayRate)) {
        valid = false;
        setShowWarning(true);
      }
    }
    return valid;
  };

  const canEdit = ["FcStoreManager", "FcOpsMgr", "FcSalesRep"].includes(fcRole);

  const header = () => (
    <thead className="table-root-floor__header">
      <tr className="table-root-floor__header__tr">
        {expPriceHeaders.map((col) => {
          if (canEdit && ["Edit", "Delete"].includes(col.name)) {
            return (
              <th
                key={col.id}
                className={`table-root-floor__header__tr__th table-root-floor__body__tr__td__text ${col.class}`}
              />
            );
          }
          if (col.name !== "Edit" && col.name !== "Delete") {
            return (
              <th
                key={col.id}
                className={`table-root-floor__header__tr__th table-root-floor__body__tr__td__nextLine_text ${col.class}`}
              >
                <div>{col.name}</div>
              </th>
            );
          }
        })}
      </tr>
    </thead>
  );

  const displayRowItem = (row, col) => {
    if (row && col && col.dataKey && row[col.dataKey]) {
      if (
        col.name &&
        (col.name === "Exception Bill Rate" ||
          col.name === "Standard Bill Rate" ||
          col.name === "Standard Installer Pay Rate" ||
          col.name === "Exception Installer Pay Rate")
      ) {
        return currencyValue(row[col.dataKey]);
      } else {
        return row[col.dataKey];
      }
    } else {
      return "";
    }
  };

  const renderRows = () => {
    return exceptionPriceSearchList.map((row, index) => (
      <tr key={index} className="table-root-floor__body__tr">
        {expPriceHeaders.map((col) => {
          const key = `${row.id}-${col.id}`;
          if (col.name === "Labor Code") {
            return (
              <td className={`${tdClass} mobile-data__row__column__item__top__left__name--text`} key={key}>
                <CustomTooltip placement="top" trigger="hover" text={`${row.laborCode}- ${row.description}`}>
                  <span>{`${row.laborCode} - ${row.description}`}</span>
                </CustomTooltip>
              </td>
            );
          }
          if (col.name === "Edit" && ["FcStoreManager", "FcOpsMgr", "FcSalesRep"].includes(fcRole)) {
            return (
              <td className={`${tdClass} 'actions-align'`} key={key}>
                <img src={pencil} className="actions-align" alt="edit" onClick={() => handleEditPrice(row)} />
              </td>
            );
          }

          if (col.name === "Delete" && ["FcStoreManager", "FcOpsMgr", "FcSalesRep"].includes(fcRole)) {
            return (
              <td className={`${tdClass} 'actions-align'`} key={key}>
                <img src={deleteIcon} className="actions-align" alt="delete" onClick={() => handleDeletePrice(row)} />
              </td>
            );
          }

          if (col.name !== "Edit" && col.name !== "Delete" && col.name !== "Labor Code") {
            return (
              <td className={tdClass} key={key}>
                {displayRowItem(row, col)}
              </td>
            );
          }
        })}
      </tr>
    ));
  };

  const renderMobileRows = (currentData) => {
    return currentData.map((row, index) => {
      return (
        <div className="mobile-data__row__column__item" key={`${row.id}-${index}`}>
          <div className="mobile-data__row__column__item__top hide-color">
            <div className="d-flex mobile-data__row__column__item__top__items">
              <div className="d-flex justify-content-between mobile-data__row__column__item__top__left ">
                <div
                  className="mobile-data__row__column__item__top__left__icon custom-collapse__container"
                  data-bs-toggle="collapse"
                  data-bs-target={"#collapse_" + row.id + index}
                  aria-expanded="false"
                  aria-controls={"#collapse_" + row.id + index}
                >
                  <span className="expand-collapse"></span>
                </div>
              </div>
              <div className="mobile-data__row__column__item__top__left__name">
                <span className="mobile-data__row__column__item__top__left__name--text">
                  {row.laborCode + " - " + row.description}
                </span>
              </div>
            </div>
          </div>
          <div className="collapse mobile-data__row__column__item__content" id={"collapse_" + row.id + index}>
            {expPriceHeaders &&
              expPriceHeaders.map((item, i) => {
                return (
                  <div key={i} className={`mobile-data__row__column__item__content__item ${item.classNameOne}`}>
                    {item.name !== "Checkbox" && (
                      <div className="mobile-data__row__column__item__content__item__flex">
                        <div className="mobile-data__row__column__item__content__item__flex--key">{item.name}:</div>
                        <div className="d-flex mobile-data__row__column__item__content__item__flex--value">
                          {item.name === "Edit" && (
                            <img
                              src={pencil}
                              className="actions-align"
                              alt={"pencil-icon"}
                              onClick={() => handleEditPrice(row)}
                            />
                          )}
                          {item.name === "Delete" && (
                            <img
                              src={deleteIcon}
                              className="actions-align"
                              alt={"delete-icon"}
                              onClick={() => handleDeletePrice(row)}
                            />
                          )}
                          {item.name !== "Edit" && item.name !== "Delete" && displayMobileRowItem(row, item)}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
          </div>
        </div>
      );
    });
  };
  const handleLaborView = () => {
    navigate("/laborTable");
  };

  return (
    <>
      <div className="container-fluid search-form-container">
        <div className="search-form-container__title d-md-flex justify-content-between align-items-md-center flex-column flex-md-row align-items-md-center">
          <span className="search-form-container__title--text mb-5 mb-md-0">
            {!isMobile && <img src={quote} alt="quote" />}&nbsp;Exception Pricing
          </span>
          <div className="d-md-flex align-items-center flex-column">
            <Button variant="outline-primary" onClick={handleLaborView}>
              Back to Labor Table
            </Button>
          </div>
        </div>

        <div className="search-form-container__fields">
          <form className="search-form-container__fields__form">
            <div className="row">
              <AccountLookup
                numberFieldChangeCallback={onAccountNumberChange}
                nameFieldChangeCallback={onAccountNameChange}
                numberFieldWrapperClass="col-12 col-sm-12 col-md-6 col-lg-3 search-form-container__fields__form-group"
                nameFieldWrapperClass="col-12 col-sm-12 col-md-6 col-lg-3 search-form-container__fields__form-group"
                isExpPrice={true}
                store={storeCcn}
                handleJob={handleJob}
                jobList={jobList}
                initialAccountNumber={exceptionPriceSearchFields.accountNumber}
                initialAccountName={exceptionPriceSearchFields.accountName}
              />
            </div>

            <Button variant="primary" onClick={handleSearch}>
              <span>Search</span>
            </Button>
          </form>
        </div>
      </div>

      {showPriceTable && (
        <div className="container-fluid search-form-container">
          <div className="d-flex justify-content-between">
            <span className="table-items__title--text table-items__title--textAlign">Search Results</span>
            {["FcStoreManager", "FcOpsMgr", "FcSalesRep"].includes(fcRole) && isExpPrice && (
              <div className="d-flex">
                <Button variant="outline-primary" className="m-0 mb-2" onClick={() => handleAddExceptionPrice(true)}>
                  Add Exception Price
                </Button>
              </div>
            )}
          </div>

          {isShowAddLaborCodes && (
            <>
              <div className="d-flex flex-column px-4 mx-3 py-4 px-md-0 mx-md-0 labor-codes-fields-container">
                <div className="search-form-container__fields">
                  <form className="search-form-container__fields__form">
                    <div className="row align-items-center">
                      <div className="col-12 col-sm-12 col-md-6 col-lg-4 search-form-container__fields__form-group m-md-0">
                        <MultiSelectInput
                          inputRef={laborCodesNode}
                          options={
                            laborCodeLookupData
                              ? laborCodeLookupData.filter(
                                  (laborCodeItem) => !laborCodes.includes(laborCodeItem.laborCode),
                                )
                              : []
                          }
                          defaultValue="Select any labor code"
                          label="Labor Code"
                          handleSelectInput={handleLaborCodeLookupValue}
                          selectedValues={
                            laborCodeRow.laborCode && laborCodeRow.description
                              ? [laborCodeRow.laborCode + " - " + laborCodeRow.description]
                              : []
                          }
                          isLookup={true}
                          isCloseAfterSelection={true}
                        />
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-2 search-form-container__fields__form-group m-md-0">
                        <InputField
                          type="number"
                          id="exceptionBillRate"
                          refVal={autoFocus}
                          label="Exception Bill Rate"
                          placeholder={"Enter Price"}
                          fieldClasses="form-control search-form-container__fields__form-group__item"
                          value={laborCodeRow.exceptionBillRate}
                          onChange={handleLaborLookupChange}
                          disabled={false}
                          isRequired={false}
                          input_label={true}
                        />
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-2 search-form-container__fields__form-group m-md-0">
                        <InputField
                          type="number"
                          id="exceptionInstallerPayRate"
                          label="Exception Installer Pay Rate"
                          placeholder={"Enter Price"}
                          fieldClasses="form-control search-form-container__fields__form-group__item"
                          value={laborCodeRow.exceptionInstallerPayRate}
                          onChange={handleLaborLookupChange}
                          disabled={false}
                          isRequired={false}
                          input_label={true}
                        />
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-2 search-form-container__fields__form-group m-md-0 mt-md-5 mt-lg-0">
                        <InputField
                          type="text"
                          id="standardBillRate"
                          label="Standard Bill Rate"
                          fieldClasses="form-control search-form-container__fields__form-group__item"
                          value={laborCodeRow.standardBillRate}
                          disabled={true}
                          isRequired={false}
                          input_label={true}
                        />
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-2 search-form-container__fields__form-group m-md-0 mt-md-5 mt-lg-0">
                        <InputField
                          type="text"
                          id="installerPayRate"
                          label="Standard Installer Pay Rate"
                          fieldClasses="form-control search-form-container__fields__form-group__item"
                          value={laborCodeRow.installerPayRate}
                          disabled={true}
                          isRequired={false}
                          input_label={true}
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="flex-row-reverse d-flex">
                <div className="col-12 col-sm-12 col-md-2 col-lg-1 search-form-container__fields__form-group">
                  <Button
                    variant="primary"
                    className="w-100"
                    onClick={addLaborCode}
                    disabled={!laborCodeRow.exceptionBillRate && !laborCodeRow.exceptionInstallerPayRate}
                  >
                    Add
                  </Button>
                </div>
                <div className="col-12 col-sm-12 col-md-2 col-lg-1 cancel-btn">
                  <Button variant="outline-primary" className="w-100" onClick={() => handleAddExceptionPrice(false)}>
                    Cancel
                  </Button>
                </div>
              </div>
            </>
          )}

          <div className="search-table-wrapper">
            <div className="container-fluid search-table">
              <MobileDataTable
                renderMobileRows={renderMobileRows}
                currentData={exceptionPriceSearchList}
                expandedItems={expPriceHeaders}
                currencyValue={currencyValue}
                displaySearchFilter={false}
                handleEditPrice={handleEditPrice}
                handleDeletePrice={handleDeletePrice}
                isExpPricing={true}
              />
              <div className="table-responsive customer-search__table">
                <table id="example" className="table table-root-floor">
                  {header()}
                  <tbody className="table-root-floor__body" ref={tableBodyNode}>
                    {exceptionPriceSearchList.length > 0 ? (
                      renderRows()
                    ) : (
                      <tr>
                        <td colSpan={12} className="no-results--text text-center">
                          Zero results were found based on your search criteria.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
      {showEditModal && (
        <EditExceptionPriceModal
          handleSave={handleSave}
          handleCancel={handleCancel}
          editData={editData}
          searchFields={exceptionPriceSearchFields}
          handleChange={handleEditFields}
          size={"lg"}
          storeCcn={storeCcn}
          expPriceValid={priceValid}
        />
      )}
      {showWarning && (
        <Modal
          title={"Are you sure"}
          saveButtonText={"Confirm"}
          closeButtonText={"Cancel"}
          handleSave={handleSave}
          handleCancel={handleCancel}
          size={"lg"}
        >
          <p className="confirmation-text">
            Exception Bill Rate and Standard Installer Pay Rate are same. Are you sure you want to continue?
          </p>
        </Modal>
      )}

      {showDeleteModal && (
        <Modal
          title={"Delete"}
          saveButtonText={"Confirm"}
          closeButtonText={"Cancel"}
          handleSave={handleSave}
          handleCancel={handleCancel}
          saveButtonClass={"removeBtnClass"}
          size={"lg"}
        >
          <p className="confirmation-text">
            Are you sure you want to delete labor code{" "}
            <strong>
              {deleteData.laborCode} - {deleteData.description}
            </strong>{" "}
            ?
          </p>
        </Modal>
      )}
    </>
  );
};

export default ExceptionPricing;
